import { Model } from '@shared/models/model';
import { Expose, Type } from 'class-transformer';
import { Customer } from './customer.model';

export class MyCustomersList extends Model {
  @Type(() => Customer)
  @Expose()
  customers: Customer[] = [];
  @Expose() allCustomersCount: number;
}
